// extracted by css-extract-rspack-plugin
export default {"errors":"Errors-module__errors___ygRc0","icon":"Errors-module__icon___HXzgm"};